import { render, staticRenderFns } from "./addRenewal.vue?vue&type=template&id=522757e0&scoped=true&"
import script from "./addRenewal.vue?vue&type=script&lang=js&"
export * from "./addRenewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522757e0",
  null
  
)

export default component.exports